var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    staticClass: "app_detail_point_modal",
    attrs: {
      "width": "900",
      "mask-closable": false,
      "title": `${"" + $t('p1j42', '选择') + " "}${_vm.tissue}`
    },
    on: {
      "on-cancel": _vm.close
    },
    model: {
      value: _vm.modal.visible,
      callback: function ($$v) {
        _vm.$set(_vm.modal, "visible", $$v);
      },
      expression: "modal.visible"
    }
  }, [_c('Row', {
    staticClass: "content",
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(`${$t("p1j42", "选择")} ` + _vm._s(_vm.tissue))]), _c('ProTreeDetail', _vm._b({
    attrs: {
      "treeData": _vm.treeData
    }
  }, 'ProTreeDetail', _vm.$attrs, false))], 1), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(`${$t("egewi3", "已选择")} ` + _vm._s(_vm.tissue))]), _c('div', {
    staticClass: "Selected"
  }, _vm._l(_vm._selectList, function (item, index) {
    return _c('div', {
      key: _vm.getNodeKey(item, index),
      staticClass: "list-item",
      on: {
        "click": function ($event) {
          return _vm.onDelete(item);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _c('Icon', {
      staticClass: "delete",
      attrs: {
        "type": "md-close"
      }
    })], 1);
  }), 0)])], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.modal.loading
    },
    on: {
      "click": _vm.onCommit
    }
  }, [_vm._v(` ${$t("kzjg2", "确定")} `)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };